import jwt from '../../http/requests/auth/jwt/index.js'


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import axios from '../../http/axios/index.js'

const apiUrl = 'https://users.evolugy.com/v1/';
const cloudFunctionUrl = 'https://us-central1-evolugy2020.cloudfunctions.net/getToken';

function clean(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] == '' ) {
      delete obj[propName];
    }
  }
  return obj
}



export default {
    updateUser({commit, state}, payload){

        const evolugyUser = Object.keys(window.sessionStorage)
        .filter(item => item.startsWith('firebase:authUser'))[0];

        console.log('must update');
        console.log(payload)

        console.log(axios.defaults.headers.common);

        if(!axios.defaults.headers.common['Authorization']){
          const authUserKey = Object.keys(window.sessionStorage)
            .filter(item => item.startsWith('firebase:authUser'))[0];
          const authUser = JSON.parse(sessionStorage.getItem(authUserKey));
          axios.defaults.headers.common['Authorization'] = `Bearer ${authUser.stsTokenManager.accessToken}`; 
        }

        setTimeout(() => {
          var newPayload = {
            "first_name": payload.first_name,
            "last_name": payload.last_name,
            "dob": payload.dob,
            "gender": payload.gender,
            "phone": payload.phone,
            "address": payload.address,
            "address_2": payload.address_2,
            "zone": payload.zone,
            "city": payload.city,
            "country": payload.country,
            "linkedin": payload.linkedin,
            "meta": payload.meta,
          }
          // delete newPayload.uid;
          // delete newPayload.uid;
          newPayload = clean(newPayload);
          
          axios.put(apiUrl+'me', newPayload, {
              headers: axios.defaults.headers.common
            }).then((result) => {
              
              console.log(result);
              commit('UPDATE_USER_INFO', result.data.data.user, {root: true});
              sessionStorage.setItem("evolugyUser", JSON.stringify(result.data.data.user));
          
            }, (error) => {
        
              console.log(error)

          });

        }, 100); 

    },
    fetchTeam({commit}){
      return new Promise((resolve, reject) => {
        axios.get(apiUrl+'')
          .then((response) => {
            commit('SET_TEAM', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
}